// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2US2W","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1l4W9"};